module.exports = __webpack_public_path__ + "static/media/logo-trans.987bfe0d.svg";